import React from "react";
import { setAdditionalClasses } from "../assets/js/utils";
import useAnimationAppear from "./hooks/useAnimationAppear";

function MainText({
  title,
  downloadableLink,
  prefix,
  downloadPath,
  applyAnimationVanishClassName,
  applyAnimationMenuAppearClassName,
}) {
  const applyAnimationAppear = useAnimationAppear();
  return (
    <div
      className={`main-text animate-main-text-appear${setAdditionalClasses(
        ["animate-main-text-appear", "animate-main-text-vanish"],
        [
          applyAnimationMenuAppearClassName || applyAnimationAppear,
          applyAnimationVanishClassName,
        ]
      )}`}
    >
      {prefix && <div className="main-text__prefix">{prefix}</div>}
      {title &&
        title.map((line, index) => (
          <h1 key={index} className="main-text__title">
            {line}
          </h1>
        ))}
      {downloadableLink && (
        <div>
          <a href={downloadPath} target={"_blank"} download>
            {downloadableLink}
          </a>
        </div>
      )}
    </div>
  );
}

export default MainText;
